export function convertSizeFile(contentLength: number) {
  const sizeInKilobytes = Math.round(contentLength / 1000)

  if (sizeInKilobytes < 1000) {
    return `${sizeInKilobytes} KB`
  } else {
    return `${Math.round(sizeInKilobytes / 1000)} MB`
  }
}
